// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Qtg_","requiredAsterisk":"Info_requiredAsterisk__1kaKK"};